export function setCaminos(state, caminos) {
    state.caminos = caminos;
}

export function setCaminoSelec(state, camino) {
    state.caminoSelec = camino;
}

export function setTarifaSelec(state, tarifa) {
    state.tarifaSelec = tarifa;
}

export function actListCaminos(state, camino) {
    if (camino !== null) {
        const index = state.caminos.findIndex(r => r.id === camino.id)
        if (index != -1) {
            state.caminos[index].codigo = camino.codigo;
            state.caminos[index].titulo = camino.titulo;
            state.caminos[index].subtitulo = camino.subtitulo;
            state.caminos[index].descripcion = camino.descripcion;
            state.caminos[index].titulo_EN = camino.titulo_EN;
            state.caminos[index].subtitulo_EN = camino.subtitulo_EN;
            state.caminos[index].descripcion_EN = camino.descripcion_EN;
            state.caminos[index].titulo_DE = camino.titulo_DE;
            state.caminos[index].subtitulo_DE = camino.subtitulo_DE;
            state.caminos[index].descripcion_DE = camino.descripcion_DE;
            state.caminos[index].orden = camino.orden;
            state.caminos[index].distancia = camino.distancia;
            state.caminos[index].dificultad = camino.dificultad;
            state.caminos[index].duracion = camino.duracion;
            state.caminos[index].precio = camino.precio;
            state.caminos[index].etapas = camino.etapas;
            state.caminos[index].subcategoria_id = camino.subcategoria_id;
            state.caminos[index].subcategoria_titulo = camino.subcategoria_titulo;
        }
    }
}

export function actListEtapas(state, etapa) {
    if (etapa !== null) {
        const index = state.etapas.findIndex(r => r.id === etapa.id)
        if (index != -1) {
            state.etapas[index].titulo = etapa.titulo;
            state.etapas[index].descripcion = etapa.descripcion;
            state.etapas[index].descripcion_EN = etapa.descripcion_EN;
            state.etapas[index].descripcion_DE = etapa.descripcion_DE;
            state.etapas[index].imagen_base64 = etapa.imagen_base64;
            state.etapas[index].inicio_punto = etapa.inicio_punto;
            state.etapas[index].final_punto = etapa.final_punto;
            state.etapas[index].dificultad = etapa.dificultad;
            state.etapas[index].distancia = etapa.distancia;
            state.etapas[index].duracion = etapa.duracion;
        }
    }
}

export function actListEtapasFromCaminos(state, etapa) {
    if (etapa !== null) {
        for (let i = 0; i < state.caminos.length; i++) {
            const index = state.caminos[i].etapas.findIndex(e => e.id === etapa.id)
            if (index != -1) {
                state.caminos[i].etapas[index].titulo = etapa.titulo;
                state.caminos[i].etapas[index].descripcion = etapa.descripcion;
                state.caminos[i].etapas[index].descripcion_EN = etapa.descripcion_EN;
                state.caminos[i].etapas[index].descripcion_DE = etapa.descripcion_DE;
                state.caminos[i].etapas[index].imagen_base64 = etapa.imagen_base64;
                state.caminos[i].etapas[index].inicio_punto = etapa.inicio_punto;
                state.caminos[i].etapas[index].final_punto = etapa.final_punto;
                state.caminos[i].etapas[index].dificultad = etapa.dificultad;
                state.caminos[i].etapas[index].distancia = etapa.distancia;
                state.caminos[i].etapas[index].duracion = etapa.duracion;
            }
        }
    }
    if (state.caminoSelec != null) {
        const index = state.caminoSelec.etapas.findIndex(e => e.id === etapa.id)
        if (index != -1) {
            state.caminoSelec.etapas[index].titulo = etapa.titulo;
            state.caminoSelec.etapas[index].descripcion = etapa.descripcion;
            state.caminoSelec.etapas[index].descripcion_EN = etapa.descripcion_EN;
            state.caminoSelec.etapas[index].descripcion_DE = etapa.descripcion_DE;
            state.caminoSelec.etapas[index].imagen_base64 = etapa.imagen_base64;
            state.caminoSelec.etapas[index].inicio_punto = etapa.inicio_punto;
            state.caminoSelec.etapas[index].final_punto = etapa.final_punto;
            state.caminoSelec.etapas[index].dificultad = etapa.dificultad;
            state.caminoSelec.etapas[index].distancia = etapa.distancia;
            state.caminoSelec.etapas[index].duracion = etapa.duracion;
        }
       
    }
}

export function actDeleteListCaminos(state, id) {
    if (id != null) {
        const index = state.caminos.findIndex(r => r.id === id)
        if (index != -1) {
            state.caminos.splice(index, 1)
        }
    }
}

export function actDeleteListTarifas(state, id) {
    if (id != null) {
        const index = state.caminoSelec.tarifas.findIndex(r => r.id === id)
        if (index != -1) {
            state.caminoSelec.tarifas.splice(index, 1)
        }
    }
}

export function actAddListTarifas(state, tarifa) {
    if (tarifa != null && state.caminoSelec != null) {
        state.caminoSelec.tarifas.push(tarifa)
    }
}

export function actUpdateListTarifas(state, tarifa) {
    if (tarifa != null && state.caminoSelec != null) {
        const index = state.caminoSelec.tarifas.findIndex(r => r.id === tarifa.id)
        if (index != -1) {
            state.caminoSelec.tarifas[index].id = tarifa.id;
            state.caminoSelec.tarifas[index].fecha_desde = tarifa.fecha_desde;
            state.caminoSelec.tarifas[index].fecha_hasta = tarifa.fecha_hasta;
            state.caminoSelec.tarifas[index].precio_ind = parseFloat(tarifa.precio_ind).toFixed(2);
            state.caminoSelec.tarifas[index].precio_doble = parseFloat(tarifa.precio_doble).toFixed(2);
            state.caminoSelec.tarifas[index].precio_triple = parseFloat(tarifa.precio_triple).toFixed(2);
            state.caminoSelec.tarifas[index].suplemento_fecha_desde = tarifa.suplemento_fecha_desde;
            state.caminoSelec.tarifas[index].suplemento_fecha_hasta = tarifa.suplemento_fecha_hasta;
            state.caminoSelec.tarifas[index].suplemento = tarifa.suplemento;
        }
    }
}

export function actDeleteListEtapas(state, id) {
    if (id != null) {
        const index = state.caminoSelec.etapas.findIndex(r => r.id === id)
        if (index != -1) {
            state.caminoSelec.etapas.splice(index, 1)
        }
    }
}
